import { HorizontalBar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  name: "horizontal-bar-chart",
  extends: HorizontalBar,
  mixins: [reactiveProp],
  data: () => ({
    options: {
      legend: {
        display: false
      },
      dataset: {
        categoryPercentage: 0.6,
        barPercentage: 0.4
      },
      scales: {
        xAxes:[{
          ticks: {
            beginAtZero: true
          }
        }],

      },
      plugins: {
        tooltip: {
          callbacks: {
            labelTextColor: function() {
              return '#543453';
            }
          }
        }
      },
    }
  }),
  //props: ['options'],
  mounted () {
    this.renderChart(this.chartData, this.options)
    this.$watch(
      'chartData', () => {
        this.renderChart(this.chartData, this.options)
      }
    )
  }
}
